// src/store/store.js
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import productReducer from './slices/product-slice';
import cartReducer from './slices/cart-slice';
import wishlistReducer from './slices/wishlist-slice';

const rootReducer = combineReducers({
  // ✅ key must be "product" to match useSelector(state => state.product)
  product: productReducer,
  cart: cartReducer,
  wishlist: wishlistReducer,
});

const persistConfig = {
  key: 'flone',
  version: 1,            // must be an integer
  storage,
  whitelist: ['cart', 'wishlist'], // don't persist 'product'
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
  devTools: import.meta.env.DEV,
});

export const persistor = persistStore(store);
export { rootReducer };
